import { Link, NavLink } from "react-router-dom";
import { Search, Menu, X, ShoppingBag } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const cart = useCart();

  const linkCls = ({ isActive }) =>
    `text-[11px] tracking-overline uppercase font-bold transition-colors ${
      isActive ? "text-[#F4EAD9]" : "text-[#B0A496] hover:text-[#F4EAD9]"
    }`;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#15110F]/80 border-b border-[#2D2622]/80"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 grid grid-cols-3 items-center">
        {/* Left links (desktop) */}
        <nav className="hidden md:flex items-center gap-8">
          <NavLink data-testid="nav-shop" to="/shop" className={linkCls}>Shop</NavLink>
          <NavLink data-testid="nav-best" to="/shop?best=1" className={linkCls}>Best Sellers</NavLink>
          <NavLink data-testid="nav-journal" to="/journal" className={linkCls}>Journal</NavLink>
        </nav>

        {/* Mobile hamburger */}
        <button
          data-testid="mobile-menu-toggle"
          aria-label="Open menu"
          className="md:hidden justify-self-start text-[#F4EAD9]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X strokeWidth={1.2} /> : <Menu strokeWidth={1.2} />}
        </button>

        {/* Centered logo */}
        <Link
          data-testid="brand-logo"
          to="/"
          className="justify-self-center font-serif-display text-3xl tracking-tight leading-none gold-shimmer"
        >
          Ambdrop
        </Link>

        {/* Right utility */}
        <div className="justify-self-end flex items-center gap-6">
          <NavLink data-testid="nav-about" to="/about" className={`hidden md:inline ${''}`}>
            <span className="text-[11px] tracking-overline uppercase font-bold text-[#B0A496] hover:text-[#F4EAD9] transition-colors">About</span>
          </NavLink>
          <Link
            data-testid="header-search-link"
            to="/shop"
            aria-label="Search"
            className="text-[#F4EAD9] hover:text-[#D4AF37]"
          >
            <Search strokeWidth={1.2} size={18} />
          </Link>
          <button
            data-testid="cart-toggle"
            onClick={() => cart.setOpen(true)}
            aria-label="Open cart"
            className="relative text-[#F4EAD9] hover:text-[#D4AF37]"
          >
            <ShoppingBag strokeWidth={1.2} size={18} />
            {cart.count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-2 -right-2 bg-[#D4AF37] text-[#15110F] text-[10px] leading-none font-bold rounded-full w-4 h-4 flex items-center justify-center"
              >
                {cart.count}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[#2D2622]/60 bg-[#15110F]"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            <NavLink data-testid="m-nav-shop" to="/shop" onClick={() => setOpen(false)} className={linkCls}>Shop</NavLink>
            <NavLink data-testid="m-nav-best" to="/shop?best=1" onClick={() => setOpen(false)} className={linkCls}>Best Sellers</NavLink>
            <NavLink data-testid="m-nav-journal" to="/journal" onClick={() => setOpen(false)} className={linkCls}>Journal</NavLink>
            <NavLink data-testid="m-nav-about" to="/about" onClick={() => setOpen(false)} className={linkCls}>About</NavLink>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
